var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 230,
    viewBox: "0 0 446 230",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.713 24.01s2.082 19.129 8.425 29.659c6.34 10.53 20.755 13.63 28.027 28.641 7.276 15.011 6.736 20.787 10.485 26.531 3.75 5.745 18.417 3.46 16.819-8.7-1.599-12.16-3.34-12.451-9.296-23.937-5.955-11.485-2.033-23.553-6.389-35.62-4.355-12.067-12.925-16.283-19.171-25.733C80.369 5.4 75.72-1.142 59.89.167c-15.83 1.308-23.09 12.067-20.33 19.481 2.757 7.415 18.152 4.362 18.152 4.362",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h438v230H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.88 195.904h2.832s2.615-5.17 6.645-5.497c4.03-.327 7.187 5.125 12.198 7.087 5.01 1.963 16.665 7.069 13.07 7.069-3.593 0-36.052-1.29-36.052-1.29l1.306-7.37",
    fill: "#FFCAA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.676 149.829s-60.839 22.005-68.609 28.11c-7.767 6.107-7.043 22.681 5.23 26.17 12.27 3.49 94.181 0 94.181 0l-1.016-9.304-17.573-5.38s12.198-2.81 17.717-12.237c5.517-9.425 3.922-22.365 3.922-22.365l-33.852-4.994",
    fill: "#F15F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.891 61.048s2.688 2.181 4.648 5.598c1.96 3.416 1.017 7.778 1.017 7.778l19.355-9.312-13.04-16.567-11.98 12.503",
    fill: "#FFCAA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.831 67.3s12.289 21.808 17.519 46.67c5.227 24.86 4.066 50.158 4.066 50.158s-8.135 2.326-24.254-.872c-16.122-3.199-25.27-9.501-25.27-9.501s10.602-8.027 11.036-21.653c.437-13.626-12.198-12.899-14.813-23.657-2.612-10.76 1.016-17.301 5.954-29.805 4.938-12.503 18.408-19.046 25.762-11.34",
    fill: "#EFE6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.765 28.578c-2.277 16.14 3.785 32.904 13.974 34.344 10.19 1.44 20.647-12.99 22.924-29.13 2.275-16.138-4.494-27.874-14.683-29.313-10.19-1.44-19.94 7.96-22.215 24.1M376.332 75.37s-28.537 36.927-33.33 35.183c-4.793-1.745-25.705-31.913-25.705-31.913l-5.23 1.963s17.866 52.994 29.846 51.467c11.981-1.527 48.795-35.765 52.282-46.233 3.487-10.468-8.06-18.319-17.863-10.468",
    fill: "#FFCAA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.067 80.603s-1.45-2.835-1.813-6.179c-.365-3.344-1.164-18.828-1.164-21.227 0-2.398 3.704 1.672 5.81 9.669 2.105 7.996 2.397 15.774 2.397 15.774s-1.309 3.417-5.23 1.963",
    fill: "#FFCAA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.89 61.962s4.147-1.736 6.895-5.331c2.748-3.595 4.841-7.128 4.841-7.128l5.478 6.96-15.121 7.863-2.093-2.364",
    fill: "#F2B186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.889 189.425s-46.62 2.036-56.496 1.164c-9.875-.873-15.54-3.344-15.54-3.344l5.52 5.088-2.76 4.362s16.991-1.454 39.357 0 36.594 7.868 36.594 7.868l11.914-.453-1.016-9.305-17.573-5.38",
    fill: "#D7523C"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(307 2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#020D26",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0A303A",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.93 145.023s-4.703 9.438-2.056 18.209c2.646 8.77 22.962 15.56 21.795 20.086-1.166 4.527-25.997 4.339-25.997 4.339l-1.402 9.336s21.923 1.85 40.42 1.002c18.499-.85 12.198-20.335 3.326-29.67C98.14 158.987 93 152.48 93 152.48l-22.07-7.458",
    fill: "#07232B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.467 189.013s-2.093-2.111-4.156-2.441c-2.06-.33-2.376 1.792-3.194 3.96-.818 2.17-5.757 3.066-6.923 4.103-1.167 1.037.039 2.169 3.774 2.169s9.39-.392 9.39-.392l1.11-7.399",
    fill: "#D4E3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.001 142.485s-6.538 11.976-3.892 20.747c2.647 8.77 22.963 15.56 21.793 20.086-1.167 4.527-25.997 4.339-25.997 4.339l-1.402 9.336s16.181 1.85 34.678 1.002c18.496-.85 17.943-20.335 9.067-29.67-8.872-9.337-14.015-15.844-14.015-15.844l-20.232-9.996",
    fill: "#0A303A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.893 84.31c6.764 10.745 20.49 16.608 29.357 11.032 8.87-5.577 9.522-20.482 2.758-31.227-6.761-10.744-18.38-13.26-27.246-7.683-8.87 5.577-11.63 17.133-4.87 27.878",
    fill: "#FFCAA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.203 70.595c-1.296 1.118-2.096 4.48-.433 7.36 1.666 2.88 4.98 4.338 3.27 8.074-1.712 3.735 3.482 6.114.309 9.737-3.17 3.622-10.885 4.93-14.376-.071-3.498-5.002-2.166-11.082-4.37-14.113-2.205-3.03-10.38-8.928-4.367-18.636 6.015-9.707 11.979-8.274 14.556-10.291 2.578-2.017 7.206-6.42 11.667-5.54 4.46.88 5.028 3.68 7.967 4.227 2.941.548 9.516 2.687 11.035 7.543 1.518 4.856-.665 8.998-5.543 9.3-4.879.303-5.811-.538-8.052 1.393-2.237 1.932-4.177 3.399-7.317 3.024-3.143-.374-4.346-2.007-4.346-2.007",
    fill: "#E74C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.167 104.962s-6.773 8.635-11.42 22.597c-4.65 13.963-4.953 26.907-4.953 26.907s3.93 3.897 18.806 4.263c14.875.367 26.81-4.861 26.81-4.861s-7.065-20.696-8.386-30.856c-1.317-10.16-3.052-16-8.316-18.772-5.263-2.771-8.604-2.51-12.541.722",
    fill: "#FA9837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.703 189.013s-2.093-2.111-4.156-2.441c-2.063-.33-2.38 1.792-3.197 3.96-.815 2.17-5.754 3.066-6.92 4.103-1.17 1.037.038 2.169 3.774 2.169 3.735 0 9.387-.392 9.387-.392l1.112-7.399",
    fill: "#51495B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.594 105.487s-1.582-3.36-1.194-7.032c.391-3.673-8.205-3.683-8.205-3.683l-1.518 8.06s6.676 5.46 10.442 6.225c3.768.764 1.783-2.53.475-3.57",
    fill: "#FFCAA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.424 99.422s-5.266-.705-8.47-3.373c-.101.546-.258 1.373-.258 1.373s1.095 2.515 4.46 4.44c3.366 1.927 4.758 1.704 4.758 1.704l-.49-4.144",
    fill: "#F2B186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.97 87.178v-16.79s-.361-1.158-1.736 1.086c-1.377 2.243-2.174 6.585-1.883 8.901.289 2.316 1.158 6.803 1.158 6.803h2.46",
    fill: "#FFCAA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.15 123.902s-15.41-.534-20.88-6.254c16.902.577 20.228 1.71 20.228 1.71l.653 4.544",
    fill: "#ED8629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.37 106.345c.689-.032 17.266.001 28.996-4.01 11.73-4.012 20.448-18.96 20.448-18.96l3.155 3.803s-8.977 20.988-22.734 27.067c-13.756 6.079-24.018 7.526-31.558 5.5-7.54-2.027-5.874-13.05 1.693-13.4",
    fill: "#FFCAA6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleButton);
export default __webpack_public_path__ + "static/media/people-button.11a64daf1f169fcc45a72e1858c9dd7c.svg";
export { ForwardRef as ReactComponent };